import React, { useContext, useEffect, useState } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Components
import CardDirecciones from './CardDirecciones';
import HorizontalDivider from '../../common/HorizontalDivider';
// Icons
import iconCircleWarningBlue from '../../../assets/icons/icon_circle-warning-blue.svg';
// MuiElements
import { Box, CircularProgress, Typography } from '@mui/material';
// CustomHooks
import { toCamelCaseAllWords } from '../../../utils/Hooks/textFormatted';
import { nameFormatted, prefixFormatted } from '../../../utils/Hooks/nameFormatted';

function PantallaSeleccionConsultorio() {
    const [loader, setLoader] = useState(true);
    const [elegidoExterno, setElegidoExterno] = useState(null);
    const [elegidoOsde, setElegidoOsde] = useState(null);
    const { solicitudProps, prestadorExterno, setSolicitudProps, contratoSeleccionado, consultoriosContrato, icWithContrato } = useContext(AgendaContext);

    const { consultorioExterno } = prestadorExterno;
    const { consultorioOsde, nombre } = consultoriosContrato;

    const consultorioOsdeContratoSeleccionado = consultorioOsde?.filter(consultorio => consultorio.contrato === contratoSeleccionado);

    const consultoriosOsdeDisponibles = consultorioOsdeContratoSeleccionado?.filter(
        (consultorio) =>
            consultorio.estadoEnInteoperabilidad === 'BAJA' ||
            consultorio.estadoEnInteoperabilidad === null
    );

    const consultoriosExternosDisponibles = consultorioExterno.filter(
        (consultorio) =>
            consultorio.estadoEnInteoperabilidad === "BAJA" ||
            consultorio.estadoEnInteoperabilidad === null
    );


    const nombreFormatted = nameFormatted(nombre);
    const prefijoFormatted = prefixFormatted(nombre);

    useEffect(() => {
        setSolicitudProps({
            ...solicitudProps,
            consultorioExterno: elegidoExterno?.consultorioId,
            direccionExterno: elegidoExterno?.direccion,
            consultorioOsde: elegidoOsde?.consultorioId,
            direccionOsde: elegidoOsde?.direccion,
            nombre: nombreFormatted,
            prefix: prefijoFormatted,
            icPrestador: icWithContrato,
        });
    }, [elegidoExterno, elegidoOsde]);

    useEffect(() => {
        if (prestadorExterno !== undefined && consultoriosContrato !== undefined) {
            setLoader(false);
        }
    }, [prestadorExterno, consultoriosContrato]);

    return loader ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <CircularProgress size={24} sx={{ color: 'primary' }} />
        </Box>
    ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='h2'>Consultorios</Typography>
                <Typography variant='body1'>Para que puedas solicitar la conexión de agendas, es necesario que ambos consultorios se ubiquen en el mismo domicilio.</Typography>
            </Box>
            <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, marginBottom: 3 }}>
                    <Typography variant='h4'>Consultorio publicado en {toCamelCaseAllWords(solicitudProps.proveedor)}</Typography>
                    <Typography variant='h5'>Seleccioná el consultorio cuya agenda querés conectar.</Typography>
                </Box>
                <Box>
                    {consultoriosExternosDisponibles && consultoriosExternosDisponibles.map((consultorio) => (
                        <CardDirecciones
                            key={consultorio.consultorioId}
                            consultorio={consultorio}
                            elegido={elegidoExterno}
                            setElegido={setElegidoExterno}
                        />
                    ))}
                </Box>
            </Box>
            <HorizontalDivider />
            <Box sx={{ marginTop: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, marginBottom: 2 }}>
                    <Typography variant='h4'>Consultorio publicado en OSDE</Typography>
                    <Typography variant='h5'>Seleccioná el consultorio publicado en la cartilla de OSDE cuya agenda querés conectar.</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 3 }}>
                    <Box
                        component="img"
                        sx={{ width: "16px", height: "16px" }}
                        alt="img not found"
                        src={iconCircleWarningBlue}
                    />
                    <Typography variant='bodyS'>Solo verás los consultorios que tengan relacionadas especialidades cuyos turnos puedas conectar.</Typography>
                </Box>
                <Box>
                    {consultoriosOsdeDisponibles && consultoriosOsdeDisponibles.map((consultorio) => (
                        <CardDirecciones
                            key={consultorio.consultorioId}
                            consultorio={consultorio}
                            elegido={elegidoOsde}
                            setElegido={setElegidoOsde}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default PantallaSeleccionConsultorio;
